import script from "./NewsView.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsView.vue?vue&type=script&setup=true&lang=js"

import "./NewsView.vue?vue&type=style&index=0&id=ac99ce08&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.32_webpack@5.106.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac99ce08"]])

export default __exports__